export function getPersonaSettings(personas, persona) {
    var _a;
    return (_a = personas.find((item) => item.name === persona)) !== null && _a !== void 0 ? _a : null;
}
export function getPersonaSetting(personas, persona, settingKey) {
    const settings = getPersonaSettings(personas, persona);
    return settings ? settings[settingKey] : null;
}
export function aggregatePersonasMapBySetting(personas, settingKey) {
    return personas.reduce((acc, persona) => {
        acc[persona.name] = persona[settingKey];
        return acc;
    }, {});
}
//# sourceMappingURL=personas.utils.js.map